var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('button',{staticClass:"button is-link no_print",on:{"click":_vm.print}},[_vm._v("印刷プレビュー")]),_c('PrintElement',{ref:"print",attrs:{"tasks_data":_vm.tasks_data,"photo":_vm.photos}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }